import { useGlobalStore } from '../stores/globalState';

const Footer = () => {
  const { collapsed } = useGlobalStore();
  const year = new Date().getFullYear();

  return (
    <div
      className="sys-layout__footer"
      style={{
        width: collapsed ? 'calc(100% - 80px)' : 'calc(100% - 254px)',
      }}
    >
      <p>Copyright © {year}</p>
    </div>
  );
};

export default Footer;
